import { PaginationContext } from "./chunk-6MXG22MP.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Pagination/Pagination.Items.tsx
import { useContext, useMemo, Children, cloneElement } from "react";
import clsx from "clsx";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var PaginationEllipsis = () => /* @__PURE__ */jsx("li", {
  className: "pd:w-7 pd:text-center",
  children: "\u2026"
});
var PaginationItems = _a => {
  var _b = _a,
    {
      children: childrenProp,
      className
    } = _b,
    rest = __objRest(_b, ["children", "className"]);
  const {
    totalPages,
    pages,
    siblingPages,
    currentPage
  } = useContext(PaginationContext);
  const children = useMemo(() => {
    const itemsArray = Children.toArray(childrenProp);
    const minVisiblePages = siblingPages * 2 + 3;
    const maxVisiblePages = siblingPages * 2 + 5;
    if (totalPages <= maxVisiblePages) {
      return itemsArray.map((child, index) => cloneElement(child, {
        pageNumber: pages[index]
      }));
    }
    const firstSiblingPage = Math.max(currentPage - siblingPages, 1);
    const lastSiblingPage = Math.min(currentPage + siblingPages, totalPages);
    const showLeftEllipsis = firstSiblingPage > 3;
    const showRightEllipsis = lastSiblingPage <= totalPages - 3;
    if (!showLeftEllipsis && showRightEllipsis) {
      return /* @__PURE__ */jsxs(Fragment, {
        children: [itemsArray.slice(0, Math.max(minVisiblePages, lastSiblingPage)).map((child, index) => cloneElement(child, {
          pageNumber: pages[index]
        })), /* @__PURE__ */jsx(PaginationEllipsis, {}), cloneElement(itemsArray[totalPages - 1], {
          pageNumber: pages[totalPages - 1]
        })]
      });
    }
    if (showLeftEllipsis && !showRightEllipsis) {
      const firstVisiblePage = Math.min(totalPages - minVisiblePages, firstSiblingPage - 1);
      return /* @__PURE__ */jsxs(Fragment, {
        children: [cloneElement(itemsArray[0], {
          pageNumber: pages[0]
        }), /* @__PURE__ */jsx(PaginationEllipsis, {}), itemsArray.slice(firstVisiblePage, totalPages).map((child, index) => cloneElement(child, {
          pageNumber: pages[firstVisiblePage + index]
        }))]
      });
    }
    return /* @__PURE__ */jsxs(Fragment, {
      children: [cloneElement(itemsArray[0], {
        pageNumber: pages[0]
      }), /* @__PURE__ */jsx(PaginationEllipsis, {}), itemsArray.slice(firstSiblingPage - 1, lastSiblingPage).map((child, index) => cloneElement(child, {
        pageNumber: pages[firstSiblingPage - 1 + index]
      })), /* @__PURE__ */jsx(PaginationEllipsis, {}), cloneElement(itemsArray[totalPages - 1], {
        pageNumber: pages[totalPages - 1]
      })]
    });
  }, [childrenProp, totalPages, pages, currentPage, siblingPages]);
  return /* @__PURE__ */jsx("ol", __spreadProps(__spreadValues({}, rest), {
    className: clsx("pd:pagination__items", className),
    children
  }));
};
var Pagination_Items_default = PaginationItems;
export { Pagination_Items_default };